import { COUNTRY_CODES } from '../../../common/constants';
import { AddressTypes } from '../../../common/types';

export const getDefaultAddressTypeBasedOnCountry = (countryCode: string): AddressTypes =>
  countryCode === COUNTRY_CODES.EG ? 'apartment' : 'house';
